import { useEffect } from 'react';
import { sendMessageSyncBeacon } from '@/api/member-external-account-api';

const BEACON_THROTTLE_MS = 60_000;

let lastBeaconSentAt = 0;

function fireBeaconThrottled(): void {
  const now = Date.now();
  if (now - lastBeaconSentAt < BEACON_THROTTLE_MS) {
    return;
  }
  lastBeaconSentAt = now;
  void sendMessageSyncBeacon().catch((error: unknown) => {
    console.warn('message sync beacon failed', error);
  });
}

export function useMessageSyncBeacon(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    fireBeaconThrottled();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fireBeaconThrottled();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [enabled]);
}
